import type { WeatherSnapshot } from "@/adapters/api";

const PRECIP_PROBABILITY_THRESHOLD = 60;
const RAIN_MM_THRESHOLD = 0.5;
const RAIN_CODE_THRESHOLD = 51;

export function isWorkable(
	snapshot: WeatherSnapshot,
	probabilityFallback: number | null = null,
): boolean {
	const probability = snapshot.precipitation_probability ?? probabilityFallback;
	if (probability !== null && probability >= PRECIP_PROBABILITY_THRESHOLD) {
		return false;
	}
	if (snapshot.rain !== null && snapshot.rain > RAIN_MM_THRESHOLD) {
		return false;
	}
	if (
		snapshot.weather_code !== null &&
		snapshot.weather_code >= RAIN_CODE_THRESHOLD
	) {
		return false;
	}
	return true;
}

export function uvLabel(uv: number | null): string {
	if (uv === null) return "—";
	if (uv <= 2) return "Baixo";
	if (uv <= 5) return "Moderado";
	if (uv <= 7) return "Alto";
	if (uv <= 10) return "Muito alto";
	return "Extremo";
}

export function formatHour(
	bucketTime: string,
	utcOffsetSeconds: number,
): string {
	const local = new Date(Date.parse(bucketTime) + utcOffsetSeconds * 1000);
	return `${String(local.getUTCHours()).padStart(2, "0")}h`;
}
